"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const components_typography_Price_helpers_getPriceVariant = require("./helpers/get-price-variant.js");
const helpers_module = require("../../../chunks/helpers.module-CyAR4a3K.js");
const styles = {
  "price-type-full": "_price-type-full_1ex7c_1",
  "price-type-new": "_price-type-new_1ex7c_5",
  "price-type-old": "_price-type-old_1ex7c_9"
};
const Price = ({
  children,
  size = "medium",
  variant = "default",
  component = "span",
  "aria-label": ariaLabel,
  type,
  className,
  ...props
}) => {
  const priceVariant = components_typography_Price_helpers_getPriceVariant.getPriceVariant(size, variant);
  const priceComponent = variant === "strikethrough" ? "s" : component;
  return /* @__PURE__ */ jsxRuntime.jsxs(
    foundations_typography_Text_Text.Text,
    {
      variant: priceVariant,
      component: priceComponent,
      className: clsx.clsx(type && styles["price-type-" + type], className),
      ...props,
      children: [
        ariaLabel && /* @__PURE__ */ jsxRuntime.jsx("span", { className: helpers_module.helpers.srOnly, children: ariaLabel }),
        children
      ]
    }
  );
};
const PriceFull = ({ size, children, ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Price, { size, type: "full", ...props, children });
const PriceNew = ({ size, children, ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Price, { size, type: "new", ...props, children });
const PriceOld = ({ size, children, ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Price, { size, type: "old", variant: "strikethrough", ...props, children });
exports.Price = Price;
exports.PriceFull = PriceFull;
exports.PriceNew = PriceNew;
exports.PriceOld = PriceOld;
